import BarChart from "../../graphs/BarChart";
import React from "react";

interface Props {
  countryPercentArray: { Country: string; value: number; 2023: number; 2024: number }[];
  totalABI: number | null;
}

const PerformanceCharts : React.FC<Props> = ({  countryPercentArray, totalABI }) => {

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="chartTitleData">
          <h2 className="ChartTitle">Volume Performance vs LY</h2>
          <p>
            Volume closed at{" "}
            <span className="yellow">
              {totalABI !== null ? (totalABI > 0 ? "+" : "") + totalABI : "N/A"}%
            </span>{" "}
            vs  LY with growth observed majorly in Brazil and Colombia; decline coming in majorly from US and China. 
          </p>
        </div>
      </div>
      <div className="col-md-12">
        <div className="volumeChart">
          <div className="subVolumeChart">
            {countryPercentArray.length > 0 ? (
              <BarChart data={countryPercentArray} />
            ) : (
              <p>No chart data available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceCharts;